import { IAppointmentHistory, IClient } from "intake_shared/src/types";
import AppointmentHistory from "../AppointmentHistory/AppointmentHistory";
import styles from "./AppointmentConfirmed.module.scss";
import { Tabs } from "../../../bits/Tabs/Tabs";
import AppointmentConfirmedDetails from "./AppointmentConfirmedDetails/AppointmentConfirmedDetails";
import {
    TSaveClient,
    TUpdateClient,
    TUpdateClientByStatus,
} from "../../clientUiTypes";
import { uniqBy } from "lodash";
import IntakeSessionHistory from "../AppointmentHistory/IntakeSessionHistory";

export default function AppointmentConfirmed({
    client,
    initialHistories,
    updateClient,
    updateClientByStatus,
    onSaveClient,
}: {
    client: IClient;
    initialHistories: IAppointmentHistory[];
    updateClient: TUpdateClient;
    updateClientByStatus: TUpdateClientByStatus;
    onSaveClient: TSaveClient;
}) {
    const uniqueHistories = uniqBy(initialHistories, "id");
    const intakeSessionHistory = client.intake_session_history || [];
    const tabItems = [
        {
            key: "appointment-confirmed-details",
            label: "Appointment Details",
            children: (
                <div>
                    <div className={styles.appointmentConfirmedText}>
                        To book a new service for this client, move the client to
                        appointment settings. Existing appointment remains unaffected
                    </div>
                    <AppointmentConfirmedDetails
                        client={client}
                        updateClient={updateClient}
                        updateClientByStatus={updateClientByStatus}
                        onSaveClient={onSaveClient}
                    />
                </div>
            ),
        },
        {
            key: "appointment-confirmed-history",
            label: "Appointment History",
            count: uniqueHistories?.length || "0",
            children: (
                <AppointmentHistory
                    initialHistories={uniqueHistories}
                    client={client}
                    viewFrom="full-page"
                    showHeader={false}
                />
            ),
        },
        {
            key: "intake-session-history",
            label: "Intake Session History",
            count: intakeSessionHistory?.length || "0",
            children: (
                <IntakeSessionHistory
                    initialHistories={intakeSessionHistory}
                    client={client}
                    viewFrom="full-page"
                    showHeader={false}
                />
            ),
        },
    ];
    return <Tabs items={tabItems} className={styles.appointmentConfirmedTabs} />;
}
